export const frontEggConfig = {
    baseUrl: process.env.REACT_APP_FRONTEGG_BASEURL as string,
    clientId: process.env.REACT_APP_FRONTEGG_CLIENT_ID as string,
};
